import { render, staticRenderFns } from "./confirmTip.vue?vue&type=template&id=0231f577&scoped=true"
import script from "./confirmTip.vue?vue&type=script&lang=js"
export * from "./confirmTip.vue?vue&type=script&lang=js"
import style0 from "./confirmTip.vue?vue&type=style&index=0&id=0231f577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231f577",
  null
  
)

export default component.exports